export default __webpack_public_path__ + "static/media/lady.56010fc9.svg";